import { API } from "aws-amplify";
import Auth from "@aws-amplify/auth";
import { store } from "../../store";

const getHeaders = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const jwtToken = user.signInUserSession?.accessToken?.jwtToken;
  const headers = {};
  if (jwtToken) headers['Authorization'] = 'Bearer ' + jwtToken;
  const { loginReducer } = store.getState();
  const clientId = loginReducer?.groups?.[0];
  if (clientId) headers['BluStream-Client-ID'] = clientId;
  return headers;
};

const customerUuid = () => {
  const { loginReducer } = store.getState();
  return loginReducer?.groups?.[0];
};

export const getProvisionStatus = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/provision-status`, { headers });
};

export const getLlmSettings = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}`, { headers });
};

export const getAttributes = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/attributes`, { headers });
};

export const updateLlmSettings = async (settings) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.put("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}`, { headers, body: settings });
};

// Out-of-Scope Response (via MessageTemplate)
export const getOutOfScopeResponse = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/out-of-scope-response`, { headers });
};

export const updateOutOfScopeResponse = async (text) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.put("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/out-of-scope-response`, { headers, body: { text } });
};

// Restricted Terms
export const getRestrictedTerms = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/restricted-terms`, { headers });
};

export const addRestrictedTerm = async (term, reason) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/restricted-terms`, { headers, body: { term, reason } });
};

export const deleteRestrictedTerm = async (id) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.del("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/restricted-terms/${id}`, { headers });
};

// Competitor Terms
export const getCompetitorTerms = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/competitor-terms`, { headers });
};

export const addCompetitorTerm = async (term, reason) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/competitor-terms`, { headers, body: { term, reason } });
};

export const deleteCompetitorTerm = async (id) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.del("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/competitor-terms/${id}`, { headers });
};

// Allowed Terms (PII whitelist)
export const getAllowedTerms = async () => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.get("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/allowed-terms`, { headers });
};

export const addAllowedTerm = async (term, reason) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.post("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/allowed-terms`, { headers, body: { term, reason } });
};

export const deleteAllowedTerm = async (id) => {
  const uuid = customerUuid();
  const headers = await getHeaders();
  return API.del("blustreamREST", `/gandalfproxy/api/settings/llm/customer/${uuid}/allowed-terms/${id}`, { headers });
};
